module.exports = __webpack_public_path__ + "img/guide.4bc7e63c.png";